<template>
    <div class="szolgaltatas_box_container">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>
    <GrcWidgetLoading v-show="IsWidgetLoading" />


        <div class="szolgaltatas_box_wrapper" v-show="IsWidgetLoading==false">


            <div class="cms_iconandtext3_cont" style="background-color: rgba(255,255,255,0.5);">
            <div class="cms_iconandtext3_innercont">
                <div class="cms_iconandtext3_item">
                <img src="asset/images/pikto/nagyerteku_diag_black_red_2.svg" class="cms_iconandtext3_icon">
                <br><b>Orvosi ellátások igénylése</b>
                <br>
                <br>
                    <span  v-show="IgenyEngedelyezett==1">CT, MRI, PET-CT, endoszkópia, labor, röntgen, ultrahang, járóbeteg ellátás, egynapos sebészet</span>
                    <span  v-show="IgenyEngedelyezett==0">{{IgenyNemEngSzoveg}}</span>
                <br>
                <a href="igenybejelentes" class="painted_linkbutton color3" v-show="IgenyEngedelyezett==1">
                    <span>
                    <b>Tovább</b>
                    </span>
                </a>
                <br>
                <br>
                </div>

                <div class="cms_iconandtext3_item local_item_border_top">
                <img src="asset/images/pikto/vedohalo_black_red.svg" class="cms_iconandtext3_icon">
                <br><b>További információk</b>
                <br>
                <br>Minden, amit a Védőháló és a Prémium Egészség biztosítások szolgáltatás igénylésről tudni kell
                <br>
                <br>
                <a href="https://premiumellatas.hu/main/gyakran-ismetelt-kerdesek" target="_blank" class="painted_linkbutton color3">
                    <span>
                    <b>Tovább</b>
                    </span>
                </a>
                <br>
                <br>
                </div>


            </div>
            </div>

            <div class="cms_iconandtext3_cont" style="background-color: rgba(255,255,255,0.5); border-top: solid 1px #ccc;">
            <div class="cms_iconandtext3_innercont">

                <div class="cms_iconandtext3_item">
                <img src="asset/images/pikto/kritikus_betegsegek_black_red_2.svg" class="cms_iconandtext3_icon">
                <br><b>Súlyos betegségem van</b>
                <br>
                <br>Kritikus betegség keret tájékoztató:
                <br>
                  <a href="https://premiumellatas.hu/main/kritikus-betegseg-fedezet-igenyles" target="_blank" class="painted_linkbutton2 color3" style="margin: 4px 4px 4px 0px;">
                      <span><i class="fal fa-circle-info" style="margin-right: 4px;"></i>Információk</span>
                  </a>                                        
                <br>
                <br>
                
                <a href="kritikus-keret-igenyles" class="painted_linkbutton color3">
                    <span>
                    <b>Keret igénylés</b>
                    </span>
                </a>
                <br>
                <br>
                </div>



                <div class="cms_iconandtext3_item local_item_border_top">
                <img src="asset/images/pikto/orvosi_idopont_fogl_black_red.svg" class="cms_iconandtext3_icon">
                <br><b>Daganat S.O.S.</b>
                <br>
                <br>
                    <span  v-show="DaganatSOS_IgenyEngedelyezett==1">Sürgősségi kivizsgálás daganatgyanú és kifejezett daganatgyanú esetén</span>
                    <span  v-show="DaganatSOS_IgenyEngedelyezett==0">{{DaganatSOS_IgenyNemEngSzoveg}}</span>
                <br>
                <br>
                  <a href="https://premiumellatas.hu/main/daganat-sos" target="_blank" class="painted_linkbutton2 color3" style="margin: 4px 4px 4px 0px;">
                      <span><i class="fal fa-circle-info" style="margin-right: 4px;"></i>Információk</span>
                  </a>                                        
                <br>
                <br>

                <a href="daganat-sos-igenybejelentes" class="painted_linkbutton color3" v-show="DaganatSOS_IgenyEngedelyezett==1">
                    <span>
                    <b>Tovább</b>
                    </span>
                </a>
                <br>
                <br>
                </div>


                <div class="cms_iconandtext3_item local_item_border_top">
                <img src="asset/images/pikto/regisztracio_online_black_red.svg" class="cms_iconandtext3_icon" style="height:80px;">
                <br><b>Molekuláris diagnosztika</b>
                <br>
                <br>
                    <span  v-show="Molekularis_IgenyEngedelyezett==1">Molekuláris diagnosztikai kritikus betegség esetén</span>
                    <span  v-show="Molekularis_IgenyEngedelyezett==0">{{Molekularis_IgenyNemEngSzoveg}}</span>
                <br>
                <br>
                  <a href="https://premiumellatas.hu/main/molekularis-diagnosztika" target="_blank" class="painted_linkbutton2 color3" style="margin: 4px 4px 4px 0px;">
                      <span><i class="fal fa-circle-info" style="margin-right: 4px;"></i>Információk</span>
                  </a>                                        
                <br>
                <br>

                <a href="molekularis-diagnosztika-igenybejelentes" class="painted_linkbutton color3" v-show="Molekularis_IgenyEngedelyezett==1">
                    <span>
                    <b>Tovább</b>
                    </span>
                </a>
                <br>
                <br>
                </div>


            </div>
            </div>




        </div>

    </div>
</template>

<script>

import axios from "axios";
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcWidgetLoading from '../GrcComponents/GrcWidgetLoading.vue'


export default {
  name: 'frmDashboard_Szolgaltatasok',
  components: {
      GrcDB,
      GrcButton,
      GrcDialog,
      GrcWidgetLoading
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmDashboard_Szolgaltatasok",
          IsWidgetLoading: false,
          IgenyEngedelyezett:0,
          IgenyNemEngSzoveg:"",

          DaganatSOS_IgenyEngedelyezett:0,
          DaganatSOS_IgenyNemEngSzoveg:"",

          Molekularis_IgenyEngedelyezett:0,
          Molekularis_IgenyNemEngSzoveg:"",
         
          
          KritikusSzamlaEngedely:0,
      }
  },
  model: {
  },  
  methods:{

      SetControlToFocus(pNextComp)
      {
        this.$refs[pNextComp].SetFocus();
      },

      SetToDefault()
      {
        this.IsWidgetLoading = true;
      },

      SetItems(pItems)
      {
        this.IsWidgetLoading = false;
        this.Items = pItems;
      },


      Init()
      {
        this.IgenyEngedelyezett = 0;
        this.IgenyNemEngSzoveg = "";
        this.DaganatSOS_IgenyEngedelyezett = 0;
        this.DaganatSOS_IgenyNemEngSzoveg = "";

        this.Molekularis_IgenyEngedelyezett = 0;
        this.Molekularis_IgenyNemEngSzoveg = "";


        this.KritikusSzamlaEngedely = 0;


        this.IsWidgetLoading = true;

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: gDashboardUgyfelID,
        };
        var Q;

        this.$refs.GRCDB.GetData(this.WSPREFIX+"_GetData", QP).then(res => { 
            Q = res; 
            this.IsWidgetLoading = false;

            if (Q.APPERR[0].ERR != "")
            {
                //alert(Q.APPERR[0].ERR);
                return;
            }

            this.IgenyEngedelyezett = Q.DATA[0].IgenyEngedelyezett;
            this.IgenyNemEngSzoveg = Q.DATA[0].IgenyNemEngSzoveg;
            this.DaganatSOS_IgenyEngedelyezett = Q.DATA[0].DaganatSOS_IgenyEngedelyezett;
            this.DaganatSOS_IgenyNemEngSzoveg = Q.DATA[0].DaganatSOS_IgenyNemEngSzoveg;
            this.Molekularis_IgenyEngedelyezett = Q.DATA[0].Molekularis_IgenyEngedelyezett;
            this.Molekularis_IgenyNemEngSzoveg = Q.DATA[0].Molekularis_IgenyNemEngSzoveg;

            this.KritikusSzamlaEngedely = Q.DATA[0].KritikusSzamlaEngedely;

        });
      },


    async ShowInfo(pText)
    {
      window.open(pText, "_blank");
    },

    


  },
  created()
  {

  },
  mounted()
  {
      

  }

}


</script>


<style scoped>

.szolgaltatas_box_container
{
  width:100%;
  box-sizing: border-box;
}


.szolgaltatas_box_wrapper
{
  width:100%;
  box-sizing: border-box;
}

.kk_link
{
  background-color: var(--themecolor3);
  color:#fff;
  padding:8px;
  text-decoration: none;
  font-size: 15px;
  line-height: 22px;
  border-radius: 8px;
}

.kk_link:visited
{
  color:#fff;
  text-decoration: none;
}

.kk_link:hover
{
  opacity:0.8;
  text-decoration: none;
}

.local_item_border_top
{
  border-top:none;
}

@media(max-width:800px)
{
  .local_item_border_top
  {
    border-top:solid 1px #ccc !important;
  }
  
}

</style>